.scroll {
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.pill,
.tile,
.image {
  gap: 16px;
}

.icon {
  gap: 8px;

  @media (--reefer-media-tablet-min) {
    gap: 16px;
  }
}

.tab {
  gap: 8px;

  @media (--reefer-media-tablet-min) {
    gap: 12px;
  }
}

.unselected:hover :global(.category_icon) {
  transition: transform 150ms;
  transform: scale(1.15);
}

.tab > .unselected:hover {
  padding-bottom: 4px;
  background-color: var(--colors-grays-light);
}
